export const RESET_STORE = 'RESET_STORE';
export const ADD_APP = 'ADD_APP';
export const REMOVE_APP = 'REMOVE_APP';
export const UPDATE_INDEX = 'UPDATE_INDEX';
export const UPDATE_TABS = 'UPDATE_TABS';
export const UPDATE_APPS = 'UPDATE_APPS';
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const CHECK_VALIDITY = 'CHECK_VALIDITY';
export const CHECK_ALL_VALIDITY = 'CHECK_ALL_VALIDITY';
export const UPDATE_VALIDITY = 'UPDATE_VALIDITY';
export const UPDATE_VALUE = 'UPDATE_VALUE';
export const UPDATE_CONTAINER_VALUE = 'UPDATE_CONTAINER_VALUE';
export const REVEAL_VALIDATION = 'REVEAL_VALIDATION';
export const APP_SUBMITTED = 'APP_SUBMITTED';
export const UPDATE_TRACKINGNUMBER = 'UPDATE_TRACKINGNUMBER';
export const SET_APPFORMVALIDITY = 'SET_APPFORMVALIDITY';
export const SET_APP_DEPENDENCIES = 'SET_APP_DEPENDENCIES';
export const CALL_API_POPULATE = 'CALL_API_POPULATE';
export const CALL_API_POPULATE_START = 'CALL_API_POPULATE_START';
export const CALL_API_POPULATE_FAIL = 'CALL_API_POPULATE_FAIL';
export const CALL_API_POPULATE_SUCCESS = 'CALL_API_POPULATE_SUCCESS';
export const CALL_API_VALIDATE = 'CALL_API_VALIDATE';
export const ADD_NEW_CONTAINER = 'ADD_NEW_CONTAINER';
export const REMOVE_CONTAINER = 'REMOVE_CONTAINER';
export const RUN_RULES = 'RUN_RULES';
export const UPDATE_LOADING = 'UPDATE_LOADING';
export const UPDATE_SUBMITTING = 'UPDATE_SUBMITTING';
export const UPDATE_MEMBER_VALUE = 'UPDATE_MEMBER_VALUE';
export const UPDATE_MEMBER_VALIDITY = 'UPDATE_MEMBER_VALIDITY';
export const UPDATE_MEMBER_VISIBILITY = 'UPDATE_MEMBER_VISIBILITY';
export const UPDATE_REQUEST_TYPE = 'UPDATE_REQUEST_TYPE';
export const UPDATE_NEW_SPONSOR_ESOID = 'UPDATE_NEW_SPONSOR_ESOID';
